import React from 'react';
import classnames from 'classnames/bind';
import { PaginationBar } from 'taboola-ultimate-ui';
import { CookieConsent } from 'components/CookieConsent/CookieConsent';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { isIframeMode } from 'modules/taboola-common-frontend-modules/iframe/utils/isIframeMode';
import styles from './customPaginationBar.module.scss';

const classNameBuilder = classnames.bind(styles);

const CustomPaginationBar = ({ className, isLegalDisclaimerVisible = true, ...rest }) => {
    return (
        <PaginationBar className={classNameBuilder(className, 'container')} {...rest}>
            <div className={styles['note']}>
                {isLegalDisclaimerVisible && <FormattedMessage id="app.campaigns.reports.datagrid.legal" />}
                {isIframeMode() && <CookieConsent />}
            </div>
        </PaginationBar>
    );
};

export default CustomPaginationBar;
